import { alertLabels } from '../attributes/DeviceHealth';
import DeviceHealthNotEqualsComparator from './DeviceHealthNotEqualsComparator';
import AliasEqualsSelector from '../../attributes/filters/AliasEqualsSelector';

/**
 * Options returns an array of objects that depend on the alertLabels function:
 [
  {
    name : 'High Temperature',
    value : CONSTANTS.HIGH_TEMP
  },...
 ]
 * 
 */

let options = Object.entries(alertLabels()).map(([value, name]) => ({
  name,
  value
}));

// adds special None of These as an option to the options array
options = [{
  name: 'None of These',
  value: 'noneOfThese'
}, ...options];
export default AliasEqualsSelector.create(DeviceHealthNotEqualsComparator, options);